import { PureComponent } from 'react'
import { Empty } from 'antd'

import Box from '~/core/Box'

class BrokenComponent extends PureComponent {
    render() {
        let _style = this.props.style ? this.props.style : {}

        if (this.props.block) {
            _style = {
                height: '100%',
                width: '100%',
                backgroundColor: 'white',
            }
        }
        return (
            <Box alignItems="center" justifyContent="center" style={_style}>
                <Empty description="Something went wrong" />
            </Box>
        )
    }
}

export default BrokenComponent
